import {Inject, Injectable} from '@angular/core';
import {EntitiesChannel} from "../../../commons/angular/classes/entities-channel";
import {RouteModel} from "../../../routes/models/route.model";

@Injectable({providedIn: 'root'})
export class RoutesChannelService extends EntitiesChannel<RouteModel> {

  constructor(@Inject('firebaseService') protected firebaseService) {
    super()
  }

  getChannelName(): String {
    return "routes_changed";
  }

  getPartialChannelName(): String {
    return "routes_partial_changed";
  }

  getCreateChannelName(): String {
    return "routes_created";
  }

}
